import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard2";
import fetchData from "verticales/FetchData";
import AppLoading from "verticales/AppLoading.tsx";
import iconoErp from "assets/images/icons/icono_erp.ico";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "informes";

function CargaEc2Cuenta(props: any) {
  console.log("props....", props);
  const [blocking, setBlocking] = React.useState(false);
  const [cargaEc2, setCargaEc2] = useState({});
  useEffect(() => {
    const catData = async () => {
      setBlocking(true);
      try {
        const data = await fetchData(url, context, {
          action: "carga-erp-cpu-ram",
          cuenta: [props.cuenta],
        });
        console.log("data.......", data);
        if (Array.isArray(data.rows[0]) || data.rows.length > 0) {
          for (let obj of data.rows) {
            // console.log(obj);
            setCargaEc2(obj);
          }
        } else {
          throw new error("El dato no es array");
        }
      } catch (err) {
        console.log("Error al obtener datos", err);
      } finally {
        setBlocking(false);
      }
    };
    catData();
  }, []);

  return (
    <Grid>
      {blocking ? (
        <AppLoading titleCustom={"Loading " + props.cuenta} />
      ) : (
        <MDBox mb={4} ml={0}>
          <ComplexStatisticsCard
            color="info"
            icon={<img src={iconoErp} />}
            title={<b>{`Carga EC2 ${cargaEc2.cuenta}`}</b>}
            count={
              "CPU: " +
              cargaEc2["avg_cpu"] +
              "%" +
              "\n" +
              "|" +
              "\n" +
              "RAM: " +
              cargaEc2["avg_ram"] +
              "%"
            }
            percentage={{
              color: "success",
              amount: cargaEc2["instance_count"],
              label: "Instancias EC2",
            }}
          />
        </MDBox>
      )}
    </Grid>
  );
}

export default CargaEc2Cuenta;
